import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {o, OdataQuery} from "odata";
import {FilterComponent} from "../filter/filter.component";
import {FilterSettings, FilterOption, FilterUtils} from "../filter";

@Component({
    selector: 'number-filter',
    templateUrl: './number-filter.component.html',
})
export class NumberFilterComponent extends FilterComponent {

    @ViewChild('input1')
    firstInput: ElementRef<HTMLInputElement>;
    
    @ViewChild('input2')
    secondInput: ElementRef<HTMLInputElement>;
    
    static Options: FilterOption[] = [
        {
            Name: 'Equals',
            FilterClauseFormat: '{{0}} eq {1}',
            IsExactMatchFilter: true
        },
        {
            Name: 'Does Not Equal',
            FilterClauseFormat: '{{0}} ne {1}'
        },
        {
            Name: 'Is Greater Than',
            FilterClauseFormat: '{{0}} gt {1}'
        },
        {
            Name: 'Is Less Than',
            FilterClauseFormat: '{{0}} lt {1}'
        },
        {
            Name: 'Is Greater Than Or Equal To',
            FilterClauseFormat: '{{0}} ge {1}'
        },
        {
            Name: 'Is Less Than Or Equal To',
            FilterClauseFormat: '{{0}} le {1}'
        },
        {
            Name: 'Is Between',
            FilterClauseFormat: '{{0}} ge {1} and {{0}} le {2}'
        }
    ];
    
    public Options = NumberFilterComponent.Options;
    public SelectedOption: FilterOption;
    
    public Value1: number;
    public Value2: number;
    
    constructor() {
        super();
    }
    
    ngOnInit() {
        if (this.FilterSettings) {
            this.SelectedOption = this.FilterSettings.FilterModel.Option;
            this.Value1 = this.FilterSettings.FilterModel.Value1;
            this.Value2 = this.FilterSettings.FilterModel.Value2;
        }
        else {
            this.SelectedOption = this.Options[0];
        }
    }

    ngAfterViewInit() {
        if (this.Autofocus) {
            setTimeout(() => {
                this.firstInput.nativeElement.focus();
            }, 50);
        }
    }

    FirstInputComplete() {
        if (this.SelectedOption && this.SelectedOption.Name == 'Is Between') {
            this.secondInput.nativeElement.focus();
        }
        else {
            this.FilterInputComplete.emit();
        }
    }

    updateFilterSettings() {
        this.FilterSettingsChange.emit(new FilterSettings(
            FilterUtils.format(
                this.SelectedOption.FilterClauseFormat,
                '0',
                this.Value1,
                this.Value2),
            {
                Option: this.SelectedOption,
                Value1: this.Value1,
                Value2: this.Value2
            }
        ));
    }
    
    static ExactMatch(value: number) {
        
        let exactMatchFilter = NumberFilterComponent.Options.find(o => o.IsExactMatchFilter);
        
        return new FilterSettings(
            FilterUtils.format(
                exactMatchFilter.FilterClauseFormat,
                '0',
                value
            ),
            {
                Option: exactMatchFilter,
                Value1: value
            }
        );
    }
}
